var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrency(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4375 26L13.8333 19.7778V18H16.75C17.4861 18 18.1215 17.7444 18.6563 17.2333C19.191 16.7222 19.5139 16.0889 19.625 15.3333H13V13.5556H19.375C19.1389 13.037 18.7882 12.6111 18.3229 12.2778C17.8576 11.9444 17.3333 11.7778 16.75 11.7778H13V10H23V11.7778H20.2917C20.4861 12.0296 20.6597 12.3037 20.8125 12.6C20.9653 12.8963 21.0833 13.2148 21.1667 13.5556H23V15.3333H21.3125C21.2014 16.5926 20.7153 17.6481 19.8542 18.5C18.9931 19.3519 17.9583 19.7778 16.75 19.7778H16.1458L21.75 26H19.4375Z",
    fill: "#2C25C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/Currency.f6c7bce2456e8cb4a6d46a48cea8afa8.svg";
export { ForwardRef as ReactComponent };